import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const NONE = "__none__";

export function productionBatchLabel(b) {
  if (!b) return "—";
  const crop = b.crop_name || b.crop_code || "";
  const type = b.type_name || b.type_code || "";
  const status = String(b.status || "").replace(/_/g, " ");
  const meta = [crop, type, status].filter(Boolean).join(" · ");
  return meta ? `${b.code} · ${meta}` : b.code || `Batch #${b.id}`;
}

export function mergeBatchOptions(batches, currentId, currentCode) {
  const list = Array.isArray(batches) ? [...batches] : [];
  if (currentId && !list.some((b) => String(b.id) === String(currentId))) {
    list.unshift({
      id: Number(currentId),
      code: currentCode || `Batch #${currentId}`,
      status: "",
    });
  }
  return list;
}

/**
 * Mill-batch picker for an unload line. Empty value means “use the active / purchase batch”.
 */
export default function ProductionBatchSelect({
  batches = [],
  value,
  onChange,
  currentCode,
  placeholder = "Select mill batch…",
  disabled = false,
  allowNone = false,
  testId,
}) {
  const options = mergeBatchOptions(batches, value, currentCode);
  const selectValue = value ? String(value) : allowNone ? NONE : undefined;

  return (
    <Select
      value={selectValue}
      disabled={disabled || (!options.length && !allowNone)}
      onValueChange={(v) => onChange?.(v === NONE ? "" : v)}
    >
      <SelectTrigger className="w-full min-w-0" data-testid={testId}>
        <SelectValue placeholder={options.length ? placeholder : "No open mill batch"} />
      </SelectTrigger>
      <SelectContent>
        {allowNone && <SelectItem value={NONE}>— None —</SelectItem>}
        {options.map((b) => (
          <SelectItem key={b.id} value={String(b.id)}>
            {productionBatchLabel(b)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
